import { ID } from 'app/common/ui-next/_filter-compilations/predefined-ids'
import { canMailingTo } from 'app/common/ui-next/_filter-compilations/mailing'
import { CustomerType } from 'app/dataTypes/reports/customersType'
import { ReportType } from 'app/dataTypes/reports'

import { apiStringFromReportType } from '../../../data/_predefined/api-string-from-report-type'

export type ApiFinancesSummaryParams = {
  report_type: string
  params: {
    by_students?: boolean
    details?: boolean
    date_from: string
    date_to: string
    limits: {
      school_id: number
      year_id: number // учебный год
      customer_type: 'Все' | 'Учащиеся' | 'Сотрудники' // [Все, Учащиеся, Сотрудники]
      klass_id?: number // опционально
      student_id?: number // опционально, только для выбранного klass_id
      employee_id?: number // опционально
    }
  }
  options?: {
    send_to_email?: string // отправить на почту
  }
}

const convertCustomerType = (customerType: string) => {
  if (customerType === CustomerType.Students) return 'Учащиеся'
  if (customerType === CustomerType.Employees) return 'Сотрудники'
  return 'Все'
}
const getFormDataFromSelector = (formItem: ID, formData: FormData) => {
  const value = formData.getAll(formItem) as Array<string> | undefined
  if (value && value.length) return value
  return []
}

export const convertParams = (formData: FormData): [ApiFinancesSummaryParams, null] => {
  const orgIDs = getFormDataFromSelector(ID.org, formData)
  const customerType = formData.get(ID.customerType) as string
  const groupBy = formData.get(ID.groupBy) as 'dates' | 'students'
  const student = formData.getAll(ID.studentList) as string[]
  const employee = formData.getAll(ID.employeeList) as string[]
  const classes = formData.getAll(ID.classesList) as string[]
  const yearId = formData.get(ID.schoolYear) as string
  const periodFrom = formData.get(`${ID.periodDateFormat}From`) as string
  const periodTo = formData.get(`${ID.periodDateFormat}To`) as string
  const email = canMailingTo(formData)
  const options = email ? { send_to_email: email } : {}
  return [
    {
      report_type: apiStringFromReportType(ReportType.FinancesSummary),
      params: {
        date_from: periodFrom,
        date_to: periodTo,
        details: !!student[0],
        by_students: groupBy === 'students',
        limits: {
          school_id: orgIDs.map((id) => parseInt(id, 10))[0],
          year_id: parseInt(yearId, 10),
          customer_type: convertCustomerType(customerType),
          klass_id: classes ? parseInt(classes[0], 10) : undefined,
          student_id: student ? parseInt(student[0], 10) : undefined,
          employee_id: employee ? parseInt(employee[0], 10) : undefined,
        },
      },
      options,
    },
    null,
  ]
}
